export const FAQ_DATA = [
  {
    question: 'How do I complete a LearningCurve activity?',
    answer: 'You score points in LearningCurve by answering questions, and you complete the activity ' +
    'by reaching a designated target score. Harder questions are worth more points than easier questions. ' +
    'You earn fewer points on a given question when you take hints or make incorrect guesses before ' +
    'answering the question correctly.'
  },
  {
    question: 'Can I ever lose points that I\'ve already earned in the activity?',
    answer: 'No, you never lose points. Feel free to guess at questions, take hints, and even give ' +
    'up on a question if you really don\'t know the answer. Doing so just means that you\'ll need to ' +
    'answer at least one more question to get to the target score, but answering questions is how you learn!'
  },
  {
    question: 'How are LearningCurve activities graded?',
    answer: 'Activities are graded on a pass/fail basis. If you complete the activity (i.e. you reach the ' +
    'target score), you will receive a grade of 100%, no matter how many questions it took to get ' +
    'there. If you don\'t reach the target score, your grade for the activity will be 0%.'
  },
  {
    question: 'If the activity has a due date set, how does this affect grading?',
    answer: 'If your instructor has set a due date for the activity, you must complete it (reach the ' +
    'target score) before the due date passes to receive a grade. If you don\'t complete the activity ' +
    'before the due date passes, you\'ll receive a grade of 0%.'
  },
  {
    question: 'Can I use LearningCurve for review purposes after completing the activity?',
    answer: 'Yes, you are encouraged to keep answering questions (and therefore keep reviewing/learning ' +
    'the material) as long as you wish, even after you\'ve reached the target score and/or after the ' +
    'due date has passed. You can also leave and return to the activity any time you want (e.g. to ' +
    'review before a midterm or final exam); your current status is saved when you leave and restored when you return.'
  },
  {
    question: 'What types of questions are included in LearningCurve activities?',
    answer: 'Multiple choice, fill-in-the-blank, and for some activities, "sentence click" questions ' +
    'that ask you to identify parts of a sentence or paragraph.'
  },
  {
    question: 'How are multiple choice questions delivered?',
    answer: 'As soon as a you select a choice and click "submit," you see feedback for that choice.  If ' +
    'your choice was incorrect, you can keep guessing, read the relevant e-book page, get a hint, ' +
    'or simply be shown the answer.  No points are awarded if the "Show Me" option is chosen.'
  },
  {
    question: 'How are fill-in-the-blank questions delivered?',
    answer: 'You will see a single text field, where you can type the answer to the question and then ' +
    'click "submit."  Some fill-in-the-blank questions allow for multiple correct answers; in these ' +
    'cases, you are given equal credit regardless of which answer you type. If you type an answer ' +
    'and it\'s not counted as correct, try again or try a hint until you get the correct answer.'
  },
  {
    question: 'How is feedback given for LearningCurve questions?',
    answer: 'You\'ll receive immediate feedback as soon as you attempt to answer each LearningCurve ' +
    'question. If you guess incorrectly on a multiple choice question, you\'re usually given feedback ' +
    'on why the answer you chose is incorrect. This immediate feedback process is an important ' +
    'distinction between LearningCurve activities and most standard quizzes, where you only get ' +
    'feedback after answering all of the questions on the quiz. Use the feedback to learn and to ' +
    'correct any misconceptions you might have; don\'t worry about your grade, because you\'ll get a ' +
    '100% as long as you keep on working and finish the activity.'
  },
  {
    question: 'What hints are available in LearningCurve questions?',
    answer: 'There are two varieties of hints in LearningCurve: "auto-hints" and "content hints". ' +
    'For multiple choice questions, auto-hints take away one of the incorrect choices, revealing ' +
    'why that choice is not the correct one. For fill-in-the-blank questions, the first auto-hint ' +
    'shows how many characters are in the answer.  Subsequent auto-hints fill in those characters ' +
    'one at a time, with no more hints available once you have only three characters remaining. ' +
    'Content hints direct you toward the right answer without revealing any information about the ' +
    'choices or fill-in-the-blank characters. If a content hint is available for question, ' +
    'LearningCurve will always show it before providing auto-hints.'
  },
  {
    question: 'Can I consult the e-book or other course materials while completing a LearningCurve activity?',
    answer: 'Absolutely; in fact, you\'re encouraged to do so, since the point of doing a ' +
    'LearningCurve activity is to get you to engage with the material. A link below every question ' +
    'opens an e-book section or other reference page where you can read to find the answer to the ' +
    'question. You can click this link at any time without a penalty; it\'s like a free hint. You ' +
    'can also leave the activity at any time and pick back up where you left off any time later.'
  },
  {
    question: 'What does the Personalized Study Plan represent?',
    answer: 'Your Personalized Study Plan lets you know how well you\'re doing on the topics within ' +
    'the LearningCurve activity, by providing an accuracy score. LearningCurve activities typically ' +
    'cover three to five topics, and each question in an activity correlates with one of the activity\'s ' +
    'topics. Your accuracy for each topic is calculated as the total number of points you have earned ' +
    'from questions on that topic, divided by the total number of points you could have earned, had ' +
    'you gotten every question correct without hints or incorrect guesses. For instance, if you ' +
    'received 8 questions that could have been worth a total of 200 points, but you actually received ' +
    '150 of those points (having perhaps taken two hints and made two incorrect guesses, for instance), ' +
    'your accuracy would be 75%.'
  },
  {
    question: 'How can I use my Personalized Study Plan to better prepare me for quizzes and exams?',
    answer: 'Use these to determine what you do and don\'t know about the material covered in each ' +
    'activity. To help you learn more about the topics you need help with, you can view your ' +
    'Personalized Study Plan (PSP) at any time by clicking on the Back to Study Plan button that ' +
    'appears in the upper right corner of each question. (The PSP can also be accessed between ' +
    'questions by clicking the "Take a Break" button, or from the activity start screen if you leave ' +
    'the activity and comes back later). Your PSP shows your accuracy on each topic. Topics with ' +
    'scores above 90% are shown in green. Scores between 70% and 89% are shown in yellow. And scores ' +
    'below 70% are shown in red.  The color-coding indicates where you should prioritize your study. ' +
    'Clicking on each topic label reveals e-book sections, other reference materials, and/or activities ' +
    'related to that topic that you can use to improve your understanding.'
  }
]
